import './ContactPage.scss'

// import { useState } from 'react'

function ContactPage() {

  // const [ fullName, setFullName ] = useState('')
  // const [ email, setEmail ] = useState('')
  // const [ phoneNumber, setPhoneNumber ] = useState('')
  // const [ message, setMessage ] = useState('')

  // const [ fullNameError, setFullNameError ] = useState(false)
  // const [ emailError, setEmailError ] = useState(false)
  // const [ phoneNumberError, setPhoneNumberError ] = useState(false)
  // const [ messageError, setMessageError ] = useState(false)

  // console.log(checkingEl)

  // const resetFormError = () => {
  //   setFullNameError(false)
  //   setEmailError(false)
  //   setPhoneNumberError(false)
  //   setMessageError(false)
  // }

  // const handleOnChangeFullName = (e) => {
  //   const checkingEl = document.querySelector('.label__fullname')
  //   if(e.target.value) {
  //     checkingEl.classList.add('filled')
  //   } else {
  //     checkingEl.classList.remove('filled')
  //   }
  //   setFullName(e.target.value)
  // }
  // const handleOnChangeEmail = (e) => {
  //   const checkingEl = document.querySelector('.label__email')
  //   if(e.target.value) {
  //     checkingEl.classList.add('filled')
  //   } else {
  //     checkingEl.classList.remove('filled')
  //   }
  //   setEmail(e.target.value)
  // }
  // const handleOnChangePhoneNumber = (e) => {
  //   const checkingEl = document.querySelector('.label__phone-number')
  //   if(e.target.value) {
  //     checkingEl.classList.add('filled')
  //   } else {
  //     checkingEl.classList.remove('filled')
  //   }
  //   setPhoneNumber(e.target.value)
  // }
  // const handleOnChangeMessage = (e) => {
  //   const checkingEl = document.querySelector('.label__message')
  //   if(e.target.value) {
  //     checkingEl.classList.add('filled')
  //   } else {
  //     checkingEl.classList.remove('filled')
  //   }
  //   setMessage(e.target.value)
  // }

  // const validateEmail = (email) => {
  //   return email.match(
  //     // /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  //   );
  // }
  // const validate = () => {
  //   const isValid = document.querySelector('.email__isValid')
  //   const inputedEmail = document.querySelector('.form__email').value
  //   isValid.innerText = ''
  //   // console.log(inputedEmail)

  //   if (validateEmail(inputedEmail)) {
  //     return true
  //   } else {
  //     return false
  //   }
  //   // if (validateEmail(inputedEmail)) {
  //   //   isValid.innerText = `${inputedEmail} is good to go`
  //   //   isValid.style.color = "green"
  //   // } else {
  //   //   isValid.innerText = `Please verify your email address`
  //   //   isValid.style.color = "red"
  //   // }
  // }

  // const submitHandler = (event) => {
  //   event.preventDefault()
  //   resetFormError()

  //   if (!fullName || !validate() || !phoneNumber || !message) {
  //     if(!message) {setMessageError(true); event.target.message.focus()}
  //     if(!phoneNumber) {setPhoneNumberError(true); event.target.phoneNumber.focus()}
  //     if(!validate()) {setEmailError(true); event.target.email.focus()}
  //     if(!fullName) {setFullNameError(true); event.target.fullName.focus()}
  //   }
    
  //   // console.log(fullName)
  //   // console.log(email)
  //   // console.log(phoneNumber)
  //   // console.log(message)
  // }

  return (
    <section className='contact' id='contact'> 
      <div className='contact__container'>
        <div className='contact__header header'>
          <h1 className='header__head'>Hey! Let's Chat!</h1>
          <p className='header__description'>I am currently looking for new opportunities! if you have any questions or just want to have a chat, do not hesitate to reach out! I will do my best to get back to you ASAP!</p>
        </div>

        <a className='contact__email' href='mailto:gachuka@gmail.com' rel="noopener noreferrer" target="_blank">Say Hi</a>
        
        {/* <form className='contact__form form' onSubmit={submitHandler}>
          <div className='form__field'>
            // Full Name
            <input className={`form__input form__fullname ${fullNameError && 'form__input--error'}`} id='fullName' onChange={handleOnChangeFullName} value={fullName}></input>
            <label className='form__label label__fullname' htmlFor='fullName'>Full Name*</label>
          </div>
          <div className='form__field'>
            // Email to mail them back
            <input className={`form__input form__email ${emailError && 'form__input--error'}`} id='email' type='text' onChange={handleOnChangeEmail} value={email}></input>
            <label className='form__label label__email' htmlFor='email'>Email*</label>
            <span className='email__isValid'></span>
          </div>
          <div className='form__field'>
            // Phone number if needed
            <input className={`form__input form__phone ${phoneNumberError && 'form__input--error'}`} id='phoneNumber' onChange={handleOnChangePhoneNumber} value={phoneNumber}></input>
            <label className='form__label label__phone-number' htmlFor='phone'>Phone Number</label>
          </div>
          <div className='form__field'>
            // Message to me!
            <textarea className={`form__input form__message ${messageError && 'form__input--error'}`} id='message' type='text' onChange={handleOnChangeMessage} value={message}></textarea>
            <label className='form__label label__message' htmlFor='message'>Write a message</label>
          </div>
          <button type='submit'>Send!</button>
        </form> */}

      </div>
    </section>
  )
}

export default ContactPage